export const navColletti = [
  {
    _id: 0,
    base: 2,
    nome_it: "PLB-BOTT-API",
    nome_en: "PLB-BOTT-API",
    nome_fr: "PLB-BOTT-API",
    nome_es: "PLB-BOTT-API",
    info_it: "Altezza dietro 5cm - Altezza avanti 4cm - Lunghezza punte 9.2 - Pistagnino distanziato 2cm",
    info_en: "Altezza dietro 5cm - Altezza avanti 4cm - Lunghezza punte 9.2 - Pistagnino distanziato 2cm",
    info_fr: "Altezza dietro 5cm - Altezza avanti 4cm - Lunghezza punte 9.2 - Pistagnino distanziato 2cm",
    info_es: "Altezza dietro 5cm - Altezza avanti 4cm - Lunghezza punte 9.2 - Pistagnino distanziato 2cm",
  },
  {
    _id: 1,
    base: 2,
    nome_it: "BR-2B BOTT",
    nome_en: "BR-2B BOTT",
    nome_fr: "BR-2B BOTT",
    nome_es: "BR-2B BOTT",
    info_it: "Altezza dietro 4.5cm - Altezza avanti 3.5cm - Lunghezza punte 9 - Pistagnino distanziato 2cm",
    info_en: "Altezza dietro 4.5cm - Altezza avanti 3.5cm - Lunghezza punte 9 - Pistagnino distanziato 2cm",
    info_fr: "Altezza dietro 4.5cm - Altezza avanti 3.5cm - Lunghezza punte 9 - Pistagnino distanziato 2cm",
    info_es: "Altezza dietro 4.5cm - Altezza avanti 3.5cm - Lunghezza punte 9 - Pistagnino distanziato 2cm",
  },
  {
    _id: 2,
    base: 2,
    nome_it: "PLB BOTT",
    nome_en: "PLB BOTT",
    nome_fr: "PLB BOTT",
    nome_es: "PLB BOTT",
    info_it: "Altezza dietro 5cm - Altezza avanti 4cm - Lunghezza punte 9.5 - Pistagnino distanziato 2cm",
    info_en: "Altezza dietro 5cm - Altezza avanti 4cm - Lunghezza punte 9.5 - Pistagnino distanziato 2cm",
    info_fr: "Altezza dietro 5cm - Altezza avanti 4cm - Lunghezza punte 9.5 - Pistagnino distanziato 2cm",
    info_es: "Altezza dietro 5cm - Altezza avanti 4cm - Lunghezza punte 9.5 - Pistagnino distanziato 2cm",
  },
  {
    _id: 3,
    base: 1,
    nome_it: "BR+UN-B BOTT",
    nome_en: "BR+UN-B BOTT",
    nome_fr: "BR+UN-B BOTT",
    nome_es: "BR+UN-B BOTT",
    info_it: "Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 9 - Pistagnino distanziato 2cm",
    info_en: "Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 9 - Pistagnino distanziato 2cm",
    info_fr: "Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 9 - Pistagnino distanziato 2cm",
    info_es: "Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 9 - Pistagnino distanziato 2cm",
  },
  {
    _id: 4,
    base: 1,
    nome_it: "BR-UN-B-BOTT Punta meno uno",
    nome_en: "BR-UN-B-BOTT Punta meno uno",
    nome_fr: "BR-UN-B-BOTT Punta meno uno",
    nome_es: "BR-UN-B-BOTT Punta meno uno",
    info_it: "Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 8 - Pistagnino distanziato 2cm",
    info_en: "Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 8 - Pistagnino distanziato 2cm",
    info_fr: "Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 8 - Pistagnino distanziato 2cm",
    info_es: "Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 8 - Pistagnino distanziato 2cm",
  },
  {
    _id: 5,
    base: 1,
    nome_it: "BR+UN-B BOTT API/P-I",
    nome_en: "BR+UN-B BOTT API/P-I",
    nome_fr: "BR+UN-B BOTT API/P-I",
    nome_es: "BR+UN-B BOTT API/P-I",
    info_it: "Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 8,2 leggermente aperte - Pistagnino distanziato 2cm",
    info_en: "Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 8,2 leggermente aperte - Pistagnino distanziato 2cm",
    info_fr: "Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 8,2 leggermente aperte - Pistagnino distanziato 2cm",
    info_es: "Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 8,2 leggermente aperte - Pistagnino distanziato 2cm",
  },
  {
    _id: 6,
    base: 1,
    nome_it: "PL-TRE-UNB",
    nome_en: "PL-TRE-UNB",
    nome_fr: "PL-TRE-UNB",
    nome_es: "PL-TRE-UNB",
    info_it: "Collo Francese - Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 8,8cm",
    info_en: "Collo Francese - Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 8,8cm",
    info_fr: "Collo Francese - Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 8,8cm",
    info_es: "Collo Francese - Altezza dietro 4.5cm - Altezza avanti 3cm - Lunghezza punte 8,8cm",
  },
  {
    _id: 7,
    base: 2,
    nome_it: "GE AB 2B",
    nome_en: "GE AB 2B",
    nome_fr: "GE AB 2B",
    nome_es: "GE AB 2B",
    info_it: "Collo Italiano - Altezza dietro 4.5cm - Altezza avanti 4cm - Lunghezza punte 8,5cm",
    info_en: "Collo Italiano - Altezza dietro 4.5cm - Altezza avanti 4cm - Lunghezza punte 8,5cm",
    info_fr: "Collo Italiano - Altezza dietro 4.5cm - Altezza avanti 4cm - Lunghezza punte 8,5cm",
    info_es: "Collo Italiano - Altezza dietro 4.5cm - Altezza avanti 4cm - Lunghezza punte 8,5cm",
  },
  {
    _id: 8,
    base: 1,
    nome_it: "PL2 CH 1.5",
    nome_en: "PL2 CH 1.5",
    nome_fr: "PL2 CH 1.5",
    nome_es: "PL2 CH 1.5",
    info_it: "Collo Italiano - Altezza dietro 4cm - Altezza avanti 3.4cm - Lunghezza punte 8cm",
    info_en: "Collo Italiano - Altezza dietro 4cm - Altezza avanti 3.4cm - Lunghezza punte 8cm",
    info_fr: "Collo Italiano - Altezza dietro 4cm - Altezza avanti 3.4cm - Lunghezza punte 8cm",
    info_es: "Collo Italiano - Altezza dietro 4cm - Altezza avanti 3.4cm - Lunghezza punte 8cm",
  },
  {
    _id: 9,
    base: 1,
    nome_it: "PL2/AB",
    nome_en: "PL2/AB",
    nome_fr: "PL2/AB",
    nome_es: "PL2/AB",
    info_it: "Altezza dietro 4.5cm - Altezza avanti 3.4cm - Lunghezza punte 8.5cm leggermente aperte",
    info_en: "Altezza dietro 4.5cm - Altezza avanti 3.4cm - Lunghezza punte 8.5cm leggermente aperte",
    info_fr: "Altezza dietro 4.5cm - Altezza avanti 3.4cm - Lunghezza punte 8.5cm leggermente aperte",
    info_es: "Altezza dietro 4.5cm - Altezza avanti 3.4cm - Lunghezza punte 8.5cm leggermente aperte",
  },
  {
    _id: 10,
    base: 1,
    nome_it: "AQ/AB",
    nome_en: "AQ/AB",
    nome_fr: "AQ/AB",
    nome_es: "AQ/AB",
    info_it: "Altezza dietro 4.5cm - Altezza avanti 3.4cm - Lunghezza punte 7.7cm ravvicinate",
    info_en: "Altezza dietro 4.5cm - Altezza avanti 3.4cm - Lunghezza punte 7.7cm ravvicinate",
    info_fr: "Altezza dietro 4.5cm - Altezza avanti 3.4cm - Lunghezza punte 7.7cm ravvicinate",
    info_es: "Altezza dietro 4.5cm - Altezza avanti 3.4cm - Lunghezza punte 7.7cm ravvicinate",
  },
  {
    _id: 11,
    base: 1,
    nome_it: "HP/AB P9",
    nome_en: "HP/AB P9",
    nome_fr: "HP/AB P9",
    nome_es: "HP/AB P9",
    info_it: "Altezza dietro 4.5cm - Altezza avanti 3.4cm - Lunghezza punte 9cm piuttosto aperte",
    info_en: "Altezza dietro 4.5cm - Altezza avanti 3.4cm - Lunghezza punte 9cm piuttosto aperte",
    info_fr: "Altezza dietro 4.5cm - Altezza avanti 3.4cm - Lunghezza punte 9cm piuttosto aperte",
    info_es: "Altezza dietro 4.5cm - Altezza avanti 3.4cm - Lunghezza punte 9cm piuttosto aperte",
  },
  {
    _id: 12,
    base: 1,
    nome_it: "PAR 7.5",
    nome_en: "PAR 7.5",
    nome_fr: "PAR 7.5",
    nome_es: "PAR 7.5",
    info_it: "Collo Francese - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.5cm",
    info_en: "Collo Francese - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.5cm",
    info_fr: "Collo Francese - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.5cm",
    info_es: "Collo Francese - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.5cm",
  },
  {
    _id: 13,
    base: 1,
    nome_it: "PAR 8.5",
    nome_en: "PAR 8.5",
    nome_fr: "PAR 8.5",
    nome_es: "PAR 8.5",
    info_it: "Collo Francese - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8.5cm",
    info_en: "Collo Francese - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8.5cm",
    info_fr: "Collo Francese - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8.5cm",
    info_es: "Collo Francese - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8.5cm",
  },
  {
    _id: 14,
    base: 1,
    nome_it: "GE-H",
    nome_en: "GE-H",
    nome_fr: "GE-H",
    nome_es: "GE-H",
    info_it: "Collo Italiano - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8cm",
    info_en: "Collo Italiano - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8cm",
    info_fr: "Collo Italiano - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8cm",
    info_es: "Collo Italiano - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8cm",
  },
  {
    _id: 15,
    base: 1,
    nome_it: "GE/H-Punta meno uno",
    nome_en: "GE/H-Punta meno uno",
    nome_fr: "GE/H-Punta meno uno",
    nome_es: "GE/H-Punta meno uno",
    info_it: "Collo Italiano - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7cm",
    info_en: "Collo Italiano - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7cm",
    info_fr: "Collo Italiano - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7cm",
    info_es: "Collo Italiano - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7cm",
  },
  {
    _id: 16,
    base: 1,
    nome_it: "AG",
    nome_en: "AG",
    nome_fr: "AG",
    nome_es: "AG",
    info_it: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.7cm leggermente aperte",
    info_en: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.7cm leggermente aperte",
    info_fr: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.7cm leggermente aperte",
    info_es: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.7cm leggermente aperte",
  },
  {
    _id: 17,
    base: 1,
    nome_it: "G/L",
    nome_en: "G/L",
    nome_fr: "G/L",
    nome_es: "G/L",
    info_it: "Altezza dietro 3.8cm - Altezza avanti 2.7cm - Lunghezza punte 7.7cm leggermente chiuse",
    info_en: "Altezza dietro 3.8cm - Altezza avanti 2.7cm - Lunghezza punte 7.7cm leggermente chiuse",
    info_fr: "Altezza dietro 3.8cm - Altezza avanti 2.7cm - Lunghezza punte 7.7cm leggermente chiuse",
    info_es: "Altezza dietro 3.8cm - Altezza avanti 2.7cm - Lunghezza punte 7.7cm leggermente chiuse",
  },
  {
    _id: 18,
    base: 1,
    nome_it: "LONDON/H",
    nome_en: "LONDON/H",
    nome_fr: "LONDON/H",
    nome_es: "LONDON/H",
    info_it: "Altezza dietro 4cm - Altezza avanti 3cm - Punte arrotondate",
    info_en: "Altezza dietro 4cm - Altezza avanti 3cm - Punte arrotondate",
    info_fr: "Altezza dietro 4cm - Altezza avanti 3cm - Punte arrotondate",
    info_es: "Altezza dietro 4cm - Altezza avanti 3cm - Punte arrotondate",
  },
  {
    _id: 19,
    base: 1,
    nome_it: "PAR7.5/AP 1",
    nome_en: "PAR7.5/AP 1",
    nome_fr: "PAR7.5/AP 1",
    nome_es: "PAR7.5/AP 1",
    info_it: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.5cm abbastanza aperte",
    info_en: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.5cm abbastanza aperte",
    info_fr: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.5cm abbastanza aperte",
    info_es: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.5cm abbastanza aperte",
  },
  {
    _id: 20,
    base: 1,
    nome_it: "PAR8,5/AP 1",
    nome_en: "PAR8,5/AP 1",
    nome_fr: "PAR8,5/AP 1",
    nome_es: "PAR8,5/AP 1",
    info_it: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8.5cm abbastanza aperte",
    info_en: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8.5cm abbastanza aperte",
    info_fr: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8.5cm abbastanza aperte",
    info_es: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8.5cm abbastanza aperte",
  },
  {
    _id: 21,
    base: 1,
    nome_it: "G/L P-1",
    nome_en: "G/L P-1",
    nome_fr: "G/L P-1",
    nome_es: "G/L P-1",
    info_it: "Altezza dietro 3.8cm - Altezza avanti 2.7cm - Lunghezza punte 6.7cm abbastanza chiuse",
    info_en: "Altezza dietro 3.8cm - Altezza avanti 2.7cm - Lunghezza punte 6.7cm abbastanza chiuse",
    info_fr: "Altezza dietro 3.8cm - Altezza avanti 2.7cm - Lunghezza punte 6.7cm abbastanza chiuse",
    info_es: "Altezza dietro 3.8cm - Altezza avanti 2.7cm - Lunghezza punte 6.7cm abbastanza chiuse",
  },
  {
    _id: 22,
    base: 1,
    nome_it: "BR-API-Punta meno uno-BOTT",
    nome_en: "BR-API-Punta meno uno-BOTT",
    nome_fr: "BR-API-Punta meno uno-BOTT",
    nome_es: "BR-API-Punta meno uno-BOTT",
    info_it: "Collo corto con punte leggermente allargate - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.5 - Pistagnino distanziato 2cm",
    info_en: "Collo corto con punte leggermente allargate - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.5 - Pistagnino distanziato 2cm",
    info_fr: "Collo corto con punte leggermente allargate - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.5 - Pistagnino distanziato 2cm",
    info_es: "Collo corto con punte leggermente allargate - Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 7.5 - Pistagnino distanziato 2cm",
  },
  {
    _id: 23,
    base: 1,
    nome_it: "BR-BOTT",
    nome_en: "BR-BOTT",
    nome_fr: "BR-BOTT",
    nome_es: "BR-BOTT",
    info_it: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8.5cm - Pistagnino distanziato 2cm",
    info_en: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8.5cm - Pistagnino distanziato 2cm",
    info_fr: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8.5cm - Pistagnino distanziato 2cm",
    info_es: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8.5cm - Pistagnino distanziato 2cm",
  },
  {
    _id: 24,
    base: 1,
    nome_it: "BR-Punta meno uno-BOTT",
    nome_en: "BR-Punta meno uno-BOTT",
    nome_fr: "BR-Punta meno uno-BOTT",
    nome_es: "BR-Punta meno uno-BOTT",
    info_it: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8cm - Pistagnino distanziato 2cm",
    info_en: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8cm - Pistagnino distanziato 2cm",
    info_fr: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8cm - Pistagnino distanziato 2cm",
    info_es: "Altezza dietro 4cm - Altezza avanti 3cm - Lunghezza punte 8cm - Pistagnino distanziato 2cm",
  },
  {
    _id: 25,
    base: 0,
    nome_it: "AQ-BOTT",
    nome_en: "AQ-BOTT",
    nome_fr: "AQ-BOTT",
    nome_es: "AQ-BOTT",
    info_it: "Altezza dietro 3.7cm - Altezza avanti 2.5cm - Lunghezza punte 7.5cm",
    info_en: "Altezza dietro 3.7cm - Altezza avanti 2.5cm - Lunghezza punte 7.5cm",
    info_fr: "Altezza dietro 3.7cm - Altezza avanti 2.5cm - Lunghezza punte 7.5cm",
    info_es: "Altezza dietro 3.7cm - Altezza avanti 2.5cm - Lunghezza punte 7.5cm",
  },
  {
    _id: 26,
    base: 0,
    nome_it: "AQ-BOTT-API-P-I",
    nome_en: "AQ-BOTT-API-P-I",
    nome_fr: "AQ-BOTT-API-P-I",
    nome_es: "AQ-BOTT-API-P-I",
    info_it: "Altezza dietro 3.7cm - Altezza avanti 2.5cm - Lunghezza punte 6.5cm leggermente aperte",
    info_en: "Altezza dietro 3.7cm - Altezza avanti 2.5cm - Lunghezza punte 6.5cm leggermente aperte",
    info_fr: "Altezza dietro 3.7cm - Altezza avanti 2.5cm - Lunghezza punte 6.5cm leggermente aperte",
    info_es: "Altezza dietro 3.7cm - Altezza avanti 2.5cm - Lunghezza punte 6.5cm leggermente aperte",
  },
  {
    _id: 27,
    base: 0,
    nome_it: "AQ-BOTT-P-I",
    nome_en: "AQ-BOTT-P-I",
    nome_fr: "AQ-BOTT-P-I",
    nome_es: "AQ-BOTT-P-I",
    info_it: "Altezza dietro 3.7cm - Altezza avanti 2.5cm - Lunghezza punte 6.5cm",
    info_en: "Altezza dietro 3.7cm - Altezza avanti 2.5cm - Lunghezza punte 6.5cm",
    info_fr: "Altezza dietro 3.7cm - Altezza avanti 2.5cm - Lunghezza punte 6.5cm",
    info_es: "Altezza dietro 3.7cm - Altezza avanti 2.5cm - Lunghezza punte 6.5cm",
  },
  {
    _id: 28,
    base: 0,
    nome_it: "BON",
    nome_en: "BON",
    nome_fr: "BON",
    nome_es: "BON",
    info_it: "Altezza dietro 3.7cm - Altezza avanti 2cm - Lunghezza punte 7.5cm chiuse",
    info_en: "Altezza dietro 3.7cm - Altezza avanti 2cm - Lunghezza punte 7.5cm chiuse",
    info_fr: "Altezza dietro 3.7cm - Altezza avanti 2cm - Lunghezza punte 7.5cm chiuse",
    info_es: "Altezza dietro 3.7cm - Altezza avanti 2cm - Lunghezza punte 7.5cm chiuse",
  },
  {
    _id: 29,
    base: 0,
    nome_it: "BON/P6",
    nome_en: "BON/P6",
    nome_fr: "BON/P6",
    nome_es: "BON/P6",
    info_it: "Altezza dietro 3.7cm - Altezza avanti 2cm - Lunghezza punte 6cm chiuse",
    info_en: "Altezza dietro 3.7cm - Altezza avanti 2cm - Lunghezza punte 6cm chiuse",
    info_fr: "Altezza dietro 3.7cm - Altezza avanti 2cm - Lunghezza punte 6cm chiuse",
    info_es: "Altezza dietro 3.7cm - Altezza avanti 2cm - Lunghezza punte 6cm chiuse",
  },
  {
    _id: 30,
    base: 0,
    nome_it: "AQ-BOTT-P-I",
    nome_en: "AQ-BOTT-P-I",
    nome_fr: "AQ-BOTT-P-I",
    nome_es: "AQ-BOTT-P-I",
    info_it: "Altezza dietro 3.7cm - Altezza avanti 2cm - Lunghezza punte 8cm",
    info_en: "Altezza dietro 3.7cm - Altezza avanti 2cm - Lunghezza punte 8cm",
    info_fr: "Altezza dietro 3.7cm - Altezza avanti 2cm - Lunghezza punte 8cm",
    info_es: "Altezza dietro 3.7cm - Altezza avanti 2cm - Lunghezza punte 8cm",
  },
];

export const navPolsini = [
  {
    _id: 0,
    nome_it: "Polsino Spigolato H 7.5, un bottone",
    nome_en: "Polsino Spigolato H 7.5, un bottone",
    nome_fr: "Polsino Spigolato H 7.5, un bottone",
    nome_es: "Polsino Spigolato H 7.5, un bottone",
  },
  {
    _id: 1,
    nome_it: "Polsino Spigolato due bottoni H 7.5, due bottoni",
    nome_en: "Polsino Spigolato due bottoni H 7.5, due bottoni",
    nome_fr: "Polsino Spigolato due bottoni H 7.5, due bottoni",
    nome_es: "Polsino Spigolato due bottoni H 7.5, due bottoni",
  },
  {
    _id: 2,
    nome_it: "Polsino Spigolato H 6.5, un bottone",
    nome_en: "Polsino Spigolato H 6.5, un bottone",
    nome_fr: "Polsino Spigolato H 6.5, un bottone",
    nome_es: "Polsino Spigolato H 6.5, un bottone",
  },
  {
    _id: 3,
    nome_it: "Polsino Arrotondato H 6.5, un bottone",
    nome_en: "Polsino Arrotondato H 6.5, un bottone",
    nome_fr: "Polsino Arrotondato H 6.5, un bottone",
    nome_es: "Polsino Arrotondato H 6.5, un bottone",
  },
  {
    _id: 4,
    nome_it: "Polsino Arrotondato H 7.5, due bottoni",
    nome_en: "Polsino Arrotondato H 7.5, due bottoni",
    nome_fr: "Polsino Arrotondato H 7.5, due bottoni",
    nome_es: "Polsino Arrotondato H 7.5, due bottoni",
  },
  {
    _id: 5,
    nome_it: "Polsino Singolo per Gemelli H 7.0, spigolato",
    nome_en: "Polsino Singolo per Gemelli H 7.0, spigolato",
    nome_fr: "Polsino Singolo per Gemelli H 7.0, spigolato",
    nome_es: "Polsino Singolo per Gemelli H 7.0, spigolato",
  },
  {
    _id: 6,
    nome_it: "Polsino Doppio per Gemelli H 7.0, doppio",
    nome_en: "Polsino Doppio per Gemelli H 7.0, doppio",
    nome_fr: "Polsino Doppio per Gemelli H 7.0, doppio",
    nome_es: "Polsino Doppio per Gemelli H 7.0, doppio",
  },
  {
    _id: 7,
    nome_it: "Polsino Singolo per Gemelli H 6.5, arrotondato",
    nome_en: "Polsino Singolo per Gemelli H 6.5, arrotondato",
    nome_fr: "Polsino Singolo per Gemelli H 6.5, arrotondato",
    nome_es: "Polsino Singolo per Gemelli H 6.5, arrotondato",
  },
];

export const navChiusure = [
  {
    _id: 0,
    nome_it: "Chiusura senza finta",
    nome_en: "French closing",
    nome_fr: "Fermeture simple",
    nome_es: "Cierre francés",
    nome_ca: "Francese",
  },
  {
    _id: 1,
    nome_it: "Chiusura con finta",
    nome_en: "Standard closing",
    nome_fr: "Fermeture americaine",
    nome_es: "Cierre estándar",
    nome_ca: "Standard",
  },
  {
    _id: 2,
    nome_it: "Bottoni nascosti",
    nome_en: "Hidden closing",
    nome_fr: "Fermeture cachè",
    nome_es: "Cierre oculto",
    nome_ca: "Nascosta",
  },
];

export const navTaschini = [
  {
    _id: 0,
    nome_it: "Nessun taschino",
    nome_en: "No pocket",
    nome_fr: "Sans poches",
    nome_es: "No bolsillo",
    nome_ca: "Nessun taschino",
  },
  {
    _id: 1,
    nome_it: "Taschino arrotondato",
    nome_en: "Rounded pocket",
    nome_fr: "Poche arrondie",
    nome_es: "Bolsillo redondeado",
    nome_ca: "Taschino arrotondato",
  },
  {
    _id: 2,
    nome_it: "Taschino arrotondato con chiusura",
    nome_en: "Rounded pocket",
    nome_fr: "Poche arrondie",
    nome_es: "Bolsillo redondeado",
    nome_ca: "Taschino arrotondato",
  },
  {
    _id: 3,
    nome_it: "Taschino arrotondato con pattina",
    nome_en: "Rounded pocket",
    nome_fr: "Poche arrondie",
    nome_es: "Bolsillo redondeado",
    nome_ca: "Taschino arrotondato",
  },
  {
    _id: 4,
    nome_it: "Due taschini arrotondati",
    nome_en: "Two rounded pockets",
    nome_fr: "Deux poches arrondie",
    nome_es: "Dos bolsillos redondeados",
    nome_ca: "Due taschini arrotondati",
  },
  {
    _id: 5,
    nome_it: "Due taschini arrotondati con chiusura",
    nome_en: "Two rounded pockets",
    nome_fr: "Deux poches arrondie",
    nome_es: "Dos bolsillos redondeados",
    nome_ca: "Due taschini arrotondati",
  },
  {
    _id: 6,
    nome_it: "Due taschini arrotondati con pattina",
    nome_en: "Two rounded pockets",
    nome_fr: "Deux poches arrondie",
    nome_es: "Dos bolsillos redondeados",
    nome_ca: "Due taschini arrotondati",
  },
  {
    _id: 7,
    nome_it: "Taschino smussato",
    nome_en: "Beveled pocket",
    nome_fr: "Poche carre",
    nome_es: "Bolsillo biselado",
    nome_ca: "Taschino smussato",
  },
  {
    _id: 8,
    nome_it: "Taschino smussato con chiusura",
    nome_en: "Beveled pocket",
    nome_fr: "Poche carre",
    nome_es: "Bolsillo biselado",
    nome_ca: "Taschino smussato",
  },
  {
    _id: 9,
    nome_it: "Taschino smussato con pattina",
    nome_en: "Beveled pocket",
    nome_fr: "Poche carre",
    nome_es: "Bolsillo biselado",
    nome_ca: "Taschino smussato",
  },
  {
    _id: 10,
    nome_it: "Due taschini smussati",
    nome_en: "Two beveled pockets",
    nome_fr: "Deux poches carre",
    nome_es: "Dos bolsillos biselados",
    nome_ca: "Due taschini smussati",
  },
  {
    _id: 11,
    nome_it: "Due taschini smussati con chiusura",
    nome_en: "Two beveled pockets",
    nome_fr: "Deux poches carre",
    nome_es: "Dos bolsillos biselados",
    nome_ca: "Due taschini smussati",
  },
  {
    _id: 12,
    nome_it: "Due taschini smussati con pattina",
    nome_en: "Two beveled pockets",
    nome_fr: "Deux poches carre",
    nome_es: "Dos bolsillos biselados",
    nome_ca: "Due taschini smussati",
  },
  {
    _id: 13,
    nome_it: "Taschino western",
    nome_en: "Western pocket",
    nome_fr: "Poche western",
    nome_es: "Bolsillo western",
    nome_ca: "Bolsillo western",
  },
  {
    _id: 14,
    nome_it: "Taschino western con chiusura",
    nome_en: "Western pocket",
    nome_fr: "Poche western",
    nome_es: "Bolsillo western",
    nome_ca: "Bolsillo western",
  },
  {
    _id: 15,
    nome_it: "Taschino western con pattina",
    nome_en: "Western pocket",
    nome_fr: "Poche western",
    nome_es: "Bolsillo western",
    nome_ca: "Bolsillo western",
  },
  {
    _id: 16,
    nome_it: "Due taschini western",
    nome_en: "Two western pockets",
    nome_fr: "Deux poches western",
    nome_es: "Dos bolsillos western",
    nome_ca: "Dos bolsillos western",
  },
  {
    _id: 17,
    nome_it: "Due taschini western con chiusura",
    nome_en: "Two western pockets",
    nome_fr: "Deux poches western",
    nome_es: "Dos bolsillos western",
    nome_ca: "Dos bolsillos western",
  },
  {
    _id: 18,
    nome_it: "Due taschini western con pattina",
    nome_en: "Two western pockets",
    nome_fr: "Deux poches western",
    nome_es: "Dos bolsillos western",
    nome_ca: "Dos bolsillos western",
  },
];

export const navPinces = [
  {
    _id: 0,
    nome_it: "Dietro liscio",
    nome_en: "No pinces",
    nome_fr: "Sans pinces",
    nome_es: "Detrás liso",
    nome_ca: "Dietro Liscio",
  },
  {
    _id: 1,
    nome_it: "Piegoncino centrale",
    nome_en: "One pince",
    nome_fr: "Pinces au centre",
    nome_es: "Detrás con pinza central",
    nome_ca: "Dietro con doppia piega",
  },
  {
    _id: 2,
    nome_it: "Pieghe laterali",
    nome_en: "Double pinces",
    nome_fr: "Double pinces",
    nome_es: "Detrás con pinzas dobles",
    nome_ca: "Dietro con doppie pinces",
  },
  /*
  {
    _id: 3,
    nome_it: "Dietro con riprese",
    nome_en: "With shots",
    nome_fr: "Derrière avec des coups",
    nome_es: "Detrás con tiros",
    nome_ca: "Darrere amb trets",
  },
  */
];

export const navBottoni = [
  {
    _id: 0,
    nome_it: "Bottone Neutro 16/14 3mm",
    nome_en: "White buttons",
    nome_fr: "Boutons blanc",
    nome_es: "Botons blancos",
    info_it: "",
    info_en: "",
    info_fr: "",
    info_es: "",
  },
  {
    _id: 1,
    nome_it: "Bottone Grigio 16/14 3mm",
    nome_en: "Blue buttons",
    nome_fr: "Boutons bleu",
    nome_es: "Botons azules",
    info_it: "",
    info_en: "",
    info_fr: "",
    info_es: "",
  },
  {
    _id: 2,
    nome_it: "Bottone Nero 16/14 3mm",
    nome_en: "Light blue buttons",
    nome_fr: "Boutons bleu clair",
    nome_es: "Botons celestes",
    info_it: "",
    info_en: "",
    info_fr: "",
    info_es: "",
  },
  {
    _id: 3,
    nome_it: "Bottone Blu 16/14 3mm",
    nome_en: "Grey buttons",
    nome_fr: "Boutons gris",
    nome_es: "Botons grises",
    info_it: "",
    info_en: "",
    info_fr: "",
    info_es: "",
  },
  {
    _id: 4,
    nome_it: "Bottone Marrone 16/14 3mm",
    nome_en: "Black buttons",
    nome_fr: "Boutons noir",
    nome_es: "Botons negros",
    info_it: "",
    info_en: "",
    info_fr: "",
    info_es: "",
  },
  {
    _id: 5,
    nome_it: "Bottone Rosso 16/14 3mm",
    nome_en: "Red buttons",
    nome_fr: "Boutons rouge",
    nome_es: "Botons rojos",
    info_it: "",
    info_en: "",
    info_fr: "",
    info_es: "",
  },
  {
    _id: 6,
    nome_it: "Bottone Viola 16/14 3mm",
    nome_en: "Orange buttons",
    nome_fr: "Boutons orange",
    nome_es: "Botons naranja",
    info_it: "",
    info_en: "",
    info_fr: "",
    info_es: "",
  },
  {
    _id: 7,
    nome_it: "Bottone Lilla 16/14 3mm",
    nome_en: "Green buttons",
    nome_fr: "Boutons vert",
    nome_es: "Botons verde",
    info_it: "",
    info_en: "",
    info_fr: "",
    info_es: "",
  },
  {
    _id: 8,
    nome_it: "Bottone Verde 16/14 3mm",
    nome_en: "Pink buttons",
    nome_fr: "Boutons rose",
    nome_es: "Botons rosado",
    info_it: "",
    info_en: "",
    info_fr: "",
    info_es: "",
  },
  {
    _id: 9,
    nome_it: "Bottone Azzurro 16/14 3mm",
    nome_en: "Pink buttons",
    nome_fr: "Boutons rose",
    nome_es: "Botons rosado",
    info_it: "",
    info_en: "",
    info_fr: "",
    info_es: "",
  },
  {
    _id: 10,
    nome_it: "Bottone Celeste 16/14 3mm",
    nome_en: "Pink buttons",
    nome_fr: "Boutons rose",
    nome_es: "Botons rosado",
    info_it: "",
    info_en: "",
    info_fr: "",
    info_es: "",
  },
  {
    _id: 11,
    nome_it: "Bottone Giallo 16/14 3mm",
    nome_en: "Pink buttons",
    nome_fr: "Boutons rose",
    nome_es: "Botons rosado",
    info_it: "",
    info_en: "",
    info_fr: "",
    info_es: "",
  },
  {
    _id: 12,
    nome_it: "Bottone a Righe 16/14 3mm",
    nome_en: "Pink buttons",
    nome_fr: "Boutons rose",
    nome_es: "Botons rosado",
    info_it: "",
    info_en: "",
    info_fr: "",
    info_es: "",
  },
  {
    _id: 13,
    nome_it: "Bottone Tricolore 16/14 3mm",
    nome_en: "Pink buttons",
    nome_fr: "Boutons rose",
    nome_es: "Botons rosado",
    info_it: "",
    info_en: "",
    info_fr: "",
    info_es: "",
  },
  {
    _id: 14,
    nome_it: "Bottone Madreperla 18/14 3mm",
    nome_en: "Pink buttons",
    nome_fr: "Boutons rose",
    nome_es: "Botons rosado",
    info_it: "€ 6.00",
    info_en: "€ 6.00",
    info_fr: "€ 6.00",
    info_es: "€ 6.00",
  },
  {
    _id: 15,
    nome_it: "Bottone Madreperla 16/14 4mm",
    nome_en: "Pink buttons",
    nome_fr: "Boutons rose",
    nome_es: "Botons rosado",
    info_it: "€ 6.00",
    info_en: "€ 6.00",
    info_fr: "€ 6.00",
    info_es: "€ 6.00",
  },
  {
    _id: 16,
    nome_it: "Bottone Madreperla 16/14 3mm",
    nome_en: "Pink buttons",
    nome_fr: "Boutons rose",
    nome_es: "Botons rosado",
    info_it: "€ 6.00",
    info_en: "€ 6.00",
    info_fr: "€ 6.00",
    info_es: "€ 6.00",
  },
];

export const navAsole = [
  {
    _id: -1,
    nome_it: "Asola colore camicia",
    nome_en: "Buttonholes in the same color as the shirt",
    nome_es: "Ojal del mismo color que la camisa",
    nome_fr: "Boutonnière de la même couleur que la chemise",
    nome_ca: "Asola colore camicia",
  },
  {
    _id: 0,
    nome_it: "Asola Bianca",
    nome_en: "White buttonholes",
    nome_es: "Ojal blanco",
    nome_fr: "Boutonnière blanc",
    nome_ca: "Asola Bianca",
  },
  {
    _id: 1,
    nome_it: "Asola Blu",
    nome_en: "Blue buttonholes",
    nome_fr: "Boutonnière bleu",
    nome_es: "Ojal azul",
    nome_ca: "Asola Blu",
  },
  {
    _id: 2,
    nome_it: "Asola Celeste",
    nome_en: "Light blue buttonholes",
    nome_fr: "Boutonnière bleu clair",
    nome_es: "Ojal celeste",
    nome_ca: "Asola Celeste",
  },
  {
    _id: 3,
    nome_it: "Asola Grigia",
    nome_en: "Grey buttonholes",
    nome_fr: "Boutonnière gris",
    nome_es: "Ojal gris",
    nome_ca: "Asola Grigia",
  },
  {
    _id: 4,
    nome_it: "Asola Nera",
    nome_en: "Black buttonholes",
    nome_fr: "Boutonnière noir",
    nome_es: "Ojal negro",
    nome_ca: "Asola Nera",
  },
  {
    _id: 5,
    nome_it: "Asola Rossa",
    nome_en: "Red Buttonholes",
    nome_fr: "Boutonnière rouge",
    nome_es: "Ojal rojo",
    nome_ca: "Asola Rossa",
  },
  {
    _id: 6,
    nome_it: "Asola Arancione",
    nome_en: "Orange Buttonholes",
    nome_fr: "Boutonnière orange",
    nome_es: "Ojal naranja",
    nome_ca: "Asola arancione",
  },
  {
    _id: 7,
    nome_it: "Asola Verde",
    nome_en: "Green Buttonholes",
    nome_fr: "Boutonnière vert",
    nome_es: "Ojal verde",
    nome_ca: "Asola verde",
  },
  {
    _id: 8,
    nome_it: "Asola Rosa",
    nome_en: "Pink Buttonholes",
    nome_fr: "Boutonnière rose",
    nome_es: "Ojal rosada",
    nome_ca: "Asola Rosa",
  },
];

export const navFili = [
  {
    _id: -1,
    nome_it: "Filo colore camicia",
    nome_en: "Thread in the same color as the shirt",
    nome_es: "Hilo del mismo color que la camisa",
    nome_fr: "Fil même couleur que la chemise",
    nome_ca: "Filo colore camicia",
  },
  {
    _id: 0,
    nome_it: "Filo bianco",
    nome_en: "White thread",
    nome_fr: "Fil blanc",
    nome_es: "Hilo blanco",
    nome_ca: "Filo bianco",
  },
  {
    _id: 1,
    nome_it: "Filo blu",
    nome_en: "Blu thread",
    nome_fr: "Fil bleu",
    nome_es: "Hilo azul",
    nome_ca: "Filo Blu",
  },
  {
    _id: 2,
    nome_it: "Filo celeste",
    nome_en: "Light blue thread",
    nome_fr: "Fil bleu clair",
    nome_es: "Hilo celeste",
    nome_ca: "Filo Celeste",
  },
  {
    _id: 3,
    nome_it: "Filo grigio",
    nome_en: "Grey thread",
    nome_fr: "Fil gris",
    nome_es: "Hilo gris",
    nome_ca: "Filo Grigio",
  },
  {
    _id: 4,
    nome_it: "Filo nero",
    nome_en: "Black thread",
    nome_fr: "Fil noir",
    nome_es: "Hilo negro",
    nome_ca: "Filo Nero",
  },
  {
    _id: 5,
    nome_it: "Filo rosso",
    nome_en: "Red thread",
    nome_fr: "Fil rouge",
    nome_es: "Hilo rojo",
    nome_ca: "Filo rosso",
  },
  {
    _id: 6,
    nome_it: "Filo Arancione",
    nome_en: "Orange thread",
    nome_fr: "Fil orange",
    nome_es: "Hilo naranja",
    nome_ca: "Hilo arancione",
  },
  {
    _id: 7,
    nome_it: "Filo Verde",
    nome_en: "Green thread",
    nome_fr: "Fil vert",
    nome_es: "Hilo verde",
    nome_ca: "Hilo verde",
  },
  {
    _id: 8,
    nome_it: "Filo Rosa",
    nome_en: "Pink thread",
    nome_fr: "Fil rose",
    nome_es: "Hilo rosada",
    nome_ca: "Hilo Rosa",
  },
];

export const navContrasti = [
  {
    _id: 0,
    nome_it: "Nessun contrasto",
    nome_en: "No contrast",
    nome_fr: "No contraste",
    nome_es: "No contraste",
    nome_ca: "Nessun Contrasto",
  },
  {
    _id: 1,
    nome_it: "Hutch 2441S-W21220-0007",
    nome_en: "Hutch 2441S-W21220-0007",
    nome_fr: "Hutch 2441S-W21220-0007",
    nome_es: "Hutch 2441S-W21220-0007",
    nome_ca: "Hutch 2441S-W21220-0007",
  },
  {
    _id: 2,
    nome_it: "Rock 2317H-W22999-0001",
    nome_en: "Rock 2317H-W22999-0001",
    nome_fr: "Rock 2317H-W22999-0001",
    nome_es: "Rock 2317H-W22999-0001",
    nome_ca: "Rock 2317H-W22999-0001",
  },
  {
    _id: 3,
    nome_it: "Rock 2317H-W22993-0001",
    nome_en: "Rock 2317H-W22993-0001",
    nome_fr: "Rock 2317H-W22993-0001",
    nome_es: "Rock 2317H-W22993-0001",
    nome_ca: "Rock 2317H-W22993-0001",
  },
];

// New
export const navFondo = [
  {
    _id: 0,
    nome_it: "Fondo classico",
    nome_en: "Classic hem",
    nome_fr: "Ourlet classique",
    nome_es: "Dobladillo clásico",
    nome_ca: "Fondo classico",
  },
  {
    _id: 1,
    nome_it: "Fondo dritto",
    nome_en: "Straight hem",
    nome_fr: "Ourlet droit",
    nome_es: "Dobladillo recto",
    nome_ca: "Fondo dritto",
  },
];

export const navVesti = [
  {
    _id: "Slim",
    nome_it: "Slim",
    nome_en: "Slim",
    nome_fr: "Slim",
    nome_es: "Slim",
    nome_ca: "Slim",
  },
  {
    _id: "Regular",
    nome_it: "Regular",
    nome_en: "Regular",
    nome_fr: "Regular",
    nome_es: "Regular",
    nome_ca: "Regular",
  },
  {
    _id: "Large",
    nome_it: "Large",
    nome_en: "Large",
    nome_fr: "Large",
    nome_es: "Large",
    nome_ca: "Large",
  },
];

export const navManiche = [
  {
    _id: 0,
    nome_it: "Manica lunga",
    nome_en: "Long sleeves",
    nome_fr: "Manches longues",
    nome_es: "Mangas largas",
    nome_ca: "Manica lunga",
  },
  {
    _id: 1,
    nome_it: "Manica corta",
    nome_en: "Short sleeves",
    nome_fr: "Manches courtes",
    nome_es: "Mangas cortas",
    nome_ca: "Manica corta",
  },
];
